<template>
  <PageRenderer v-if="content" :content="content" :page-key="pageKey" />
</template>

<script>
import PageRenderer from '@/components/PageRenderer.vue';
import { getPageContent } from '@/data/pages';

export default {
  name: 'DynamicPage',
  components: { PageRenderer },
  computed: {
    pageKey() {
      return this.$route.meta.pageKey;
    },
    content() {
      return getPageContent(this.pageKey);
    },
  },
};
</script>
